import { Component, OnInit, Input, Output, EventEmitter,  ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GastroService } from '../gastro.service';
import { PathologyService } from '../pathology.service';
import { LoginService } from '../login.service';

@Component({
    selector: 'app-messenger-report',
    templateUrl: './messenger-report.component.html',
    styleUrls: ['./messenger-report.component.scss'],
    standalone: false
})
export class MessengerReportComponent implements OnInit, AfterViewChecked {
  private signaturePadInitialized = false;
  @ViewChild('signaturePad') signaturePadRef: ElementRef<HTMLCanvasElement>;
  
  messengerName: string = '';
  messengerSignature: string = '';
  signaturePad: HTMLCanvasElement | null = null;
  signaturePadCtx: CanvasRenderingContext2D | null = null;
  drawing: boolean = false;
  pathologies: any = [];
  groupedPathologies: any[] = [];
  @Input('lab') lab: string;
  @Input('reportID') inventoryId: number;
  @Output('closed') closed = new EventEmitter<any>();
  currentDate: Date = new Date();
  @Input('signed') signed: boolean;
  fromRoute: boolean = false;
  nurseSigningDate: Date | null = null;
  secretarySigningDate: Date | null = null;
  messengerSignedDate: Date | null = null;
  gastroct = 0;
  colonoct = 0;
  signing: boolean = false;

  constructor(
    private gastroService: GastroService,
    public loginService: LoginService,
    private pathologyService: PathologyService,
    private route: ActivatedRoute
  ) { }

  

  ngOnInit(): void {
    this.setupRouteParamsAndData();
  }

  ngAfterViewChecked(): void {
    if (!this.signaturePadInitialized && this.signaturePadRef && this.signaturePadRef.nativeElement) {
      this.initSignaturePad();
      this.signaturePadInitialized = true;
    }
  }

  // If lab or inventoryId are not set via @Input, get them from route params
  private setupRouteParamsAndData(): void {
    if (!this.lab) {
      this.lab = this.route.snapshot.params['lab'];
    }
    let code = null;
    if (!this.inventoryId) {
      const param = this.route.snapshot.params['reportid'];
      code = this.route.snapshot.params['code'];
      if (param !== undefined) {
        this.inventoryId = +param;
        this.fromRoute = true;
      }
    }
    
    this.pathologyService.getInventoryDetails(this.inventoryId, code).subscribe((data: any) => {
      if(data){
        if(data.MessengerName) {
          this.messengerName = data.MessengerName;
        }
        if(data.Lab) {
          this.lab = data.Lab;
        }
        if(data.NurseSigned) {
          this.nurseSigningDate = new Date(data.NurseSigned);
          if(this.loginService.userType == 'nurse'){
            this.signed = true;
          }
        }
        if(data.SecretarySigned) {
          this.secretarySigningDate = new Date(data.SecretarySigned);
        }
        if(data.MessengerDate) {
          this.messengerSignedDate = new Date(data.MessengerDate);
          this.messengerName = data.LabMessenger;
          this.signed = true;
        }
        this.getPathologies();
      }
      

    });
    
  }

  getDisplayId(id: any): string {
    if (Array.isArray(id)) {
      return id[0];
    }
    return id;
  }

  initSignaturePad(): void {
    if (!this.signaturePadRef || !this.signaturePadRef.nativeElement) return;
    const canvas = this.signaturePadRef.nativeElement;
    this.signaturePad = canvas;
    this.signaturePadCtx = canvas.getContext('2d');
    // Mouse events
    canvas.addEventListener('mousedown', (event) => this.startDraw(event));
    canvas.addEventListener('mousemove', (event) => this.draw(event));
    canvas.addEventListener('mouseup', (event) => this.endDraw(event));
    canvas.addEventListener('mouseleave', (event) => this.endDraw(event));
    // Touch events
    canvas.addEventListener('touchstart', (event) => this.startDraw(event));
    canvas.addEventListener('touchmove', (event) => this.draw(event));
    canvas.addEventListener('touchend', (event) => this.endDraw(event));
  }

  startDraw(event: MouseEvent | TouchEvent): void {
    this.drawing = true;
    if (!this.signaturePadCtx) return;
    this.signaturePadCtx.strokeStyle = '#222';
    this.signaturePadCtx.lineWidth = 2;
    this.signaturePadCtx.beginPath();
    const pos = this.getPointerPos(event);
    this.signaturePadCtx.moveTo(pos.x, pos.y);
  }

  draw(event: MouseEvent | TouchEvent): void {
    if (!this.drawing || !this.signaturePadCtx) return;
    event.preventDefault();
    const pos = this.getPointerPos(event);
    this.signaturePadCtx.lineTo(pos.x, pos.y);
    this.signaturePadCtx.stroke();
    this.signaturePadCtx.beginPath();
    this.signaturePadCtx.moveTo(pos.x, pos.y);
    this.updateMessengerSignature();
  }

  endDraw(event: MouseEvent | TouchEvent): void {
    if (!this.drawing) return;
    this.drawing = false;
    this.updateMessengerSignature();
  }

  getPointerPos(event: MouseEvent | TouchEvent): { x: number; y: number } {
    let x = 0, y = 0;
    if (event instanceof MouseEvent) {
      x = event.offsetX;
      y = event.offsetY;
    } else if ('touches' in event && event.touches.length > 0) {
      const rect = (event.target as HTMLCanvasElement).getBoundingClientRect();
      x = event.touches[0].clientX - rect.left;
      y = event.touches[0].clientY - rect.top;
    }
    return { x, y };
  }

  updateMessengerSignature(): void {
    if (this.signaturePad) {
      this.messengerSignature = this.signaturePad.toDataURL();
    }
  }

  clearMessengerSignature(): void {
    if (this.signaturePadCtx && this.signaturePad) {
      this.signaturePadCtx.clearRect(0, 0, this.signaturePad.width, this.signaturePad.height);
      this.messengerSignature = '';
    }
  }

  getPathologies(){
    this.pathologyService.prepPathologies(this.inventoryId).subscribe((data: any[]) => {
      this.pathologies = data;
      this.groupedPathologies = this.groupByExamId(Array.isArray(data) && data.length > 0 ? data : []);
    });
  }

  groupByExamId(data: any[]): any[] {
    const groups: {[key: string]: any[]} = {};
    this.gastroct = 0;
    this.colonoct = 0;
    for(let path of data) {
      if(path.ExamType == 'Gastroscopy')
        this.gastroct++;
      if(path.ExamType == 'Colonoscopy')
        this.colonoct++;
      if (!groups[path.ExamID]) {
        groups[path.ExamID] = [];
      }
      groups[path.ExamID].push(path);
    }
    return Object.keys(groups).map(ExamID => ({
      ExamID,
      pathologies: groups[ExamID]
    }));
  }

    printPopupBody(): void {
      const popupBody = document.querySelector('.popup-body');
      if (!popupBody) return;
      
      const printContents = popupBody.innerHTML;
      const printWindow = window.open('', '', 'height=600,width=800');
      
      if (!printWindow) {
        // Fallback if popup is blocked
        alert('Please allow popups for this site to print');
        return;
      }
      
      printWindow.document.write('<html><head><title>Print</title>');
      // Optionally include styles
      const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'));
      styles.forEach(style => {
        printWindow.document.write(style.outerHTML);
      });
      printWindow.document.write('</head><body>');
      printWindow.document.write(printContents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      
      // Wait for content to load before printing
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 250);
    }

    signDetails(pathologies: any[]): void {
      let pathids = [];
      for(let p of pathologies){
        pathids.push(p.AutoIndex);
      }
      this.pathologyService.signSampleDetails(this.inventoryId, pathids, this.loginService.userType, this.loginService.UID).subscribe((data) => {
        for(let i=0; i<this.groupedPathologies.length; i++){
          if(this.groupedPathologies[i].ExamID == pathologies[0].ExamID){
            if(this.loginService.userType == 'nurse') {
              // If first nurse is already signed and it's a different nurse, update second nurse
              if(this.groupedPathologies[i].pathologies[0].NurseSignature && this.groupedPathologies[i].pathologies[0].SigningNurse !== this.loginService.UID) {
                this.groupedPathologies[i].pathologies[0].NurseSignature2 = this.loginService.getUserName();
                this.groupedPathologies[i].pathologies[0].SigningNurse2 = this.loginService.UID;
              } else {
                this.groupedPathologies[i].pathologies[0].NurseSignature = this.loginService.getUserName();
                this.groupedPathologies[i].pathologies[0].SigningNurse = this.loginService.UID;
              }
            }
            if(this.loginService.userType == 'secretary') {
              this.groupedPathologies[i].pathologies[0].SecretarySignature = this.loginService.getUserName();
              this.groupedPathologies[i].pathologies[0].SigningSecretary = this.loginService.UID;
            }
            }
          }
      });
    }

    nurseSigned(): boolean {//return true is everyhting is signed by nurse
      for(let group of this.groupedPathologies) {
        if(!group.pathologies[0].NurseSignature) {
          return false;
        }
      }
      return true;
    }

    secretarySigned(): boolean {//return true is everyhting is signed by secretary
      for(let group of this.groupedPathologies) {
        if(!group.pathologies[0].SecretarySignature) {
          return false;
        }
      }
      return true;
    }

    signInventory(){
      this.pathologyService.signInventory(this.inventoryId, this.loginService.UID, this.loginService.userType).subscribe((data) => {
        this.signed = true;
        if(this.loginService.userType == 'nurse'){
          this.closed.emit();
        }
        if(this.loginService.userType == 'secretary'){
          this.secretarySigningDate = new Date();
        }
        
      });
    }

    messengerSign(): void {
      // Send messengerName and messengerSignature (base64 image)
      if (!this.messengerName || !this.messengerSignature) return;
      this.signing = true;
      this.pathologyService.sendMessengerSignature(this.inventoryId, this.messengerName, this.messengerSignature).subscribe((pdfBlob) => {
        // Emit the PDF blob to parent
        this.closed.emit(pdfBlob);
      });
    }

    getLabName(): string {
      switch(this.lab) {
        case 'patholab': return 'פטולאב';
        case 'medica': return 'מדיקה';
        case 'megalab': return 'מגהלב';
        default: return this.lab;
      }
    }
    
    removeSamplesFromInventory(pathologies: any[]): void {
      let pathids = [];
      for(let p of pathologies){
        pathids.push(p.AutoIndex);
      }
      
      this.pathologyService.removeSamplesFromInventory(this.inventoryId, pathids).subscribe({
        next: (data) => {
          // Refresh data from server to update UI
          this.getPathologies();
          
          // Check if we need to close (after a brief delay to let the server update)
          setTimeout(() => {
            if (this.pathologies.length === 0) {
              this.closed.emit();
            }
          }, 100);
        },
        error: (error) => {
          console.error('Error removing samples', error);
          alert('Error removing samples from inventory');
        }
      });
    }

    hasFirstNurseSigned(): boolean {
      // Check if any pathology group has a first nurse signature
      for(let group of this.groupedPathologies) {
        if(group.pathologies[0].NurseSignature) {
          return true;
        }
      }
      return false;
    }

  anyNurseHasSigned(): boolean {
    // Check if any nurse has signed any samples (not just current user)
    for (let group of this.groupedPathologies) {
      if (group.pathologies[0].NurseSignature) {
        return true;
      }
    }
    return false;
  }

  anySecretaryHasSigned(): boolean {
    // Check if any secretary has signed any samples (not just current user)
    for (let group of this.groupedPathologies) {
      if (group.pathologies[0].SecretarySignature) {
        return true;
      }
    }
    return false;
  }

  anySecondNurseHasSigned(): boolean {
    // Check if any second nurse has signed any samples
    for (let group of this.groupedPathologies) {
      if (group.pathologies[0].NurseSignature2) {
        return true;
      }
    }
    return false;
  }

  currentUserHasSignedAsNurse(): boolean {
    // Check if current user has signed any samples as a nurse
    for (let group of this.groupedPathologies) {
      if (group.pathologies[0].SigningNurse == this.loginService.UID) {
        return true;
      }
    }
    return false;
  }

  currentUserHasSignedAsSecretary(): boolean {
    // Check if current user has signed any samples as secretary
    for (let group of this.groupedPathologies) {
      if (group.pathologies[0].SigningSecretary == this.loginService.UID) {
        return true;
      }
    }
    return false;
  }

  currentUserHasSignedAsSecondNurse(): boolean {
    // Check if current user has signed any samples as second nurse
    for (let group of this.groupedPathologies) {
      if (group.pathologies[0].SigningNurse2 == this.loginService.UID) {
        return true;
      }
    }
    return false;
  }

  anySamplesCanBeRemoved(): boolean {
    // Check if any samples can be removed (no secretary signature AND no nurse signature)
    for (let group of this.groupedPathologies) {
      if (
        !group.pathologies[0].SecretarySignature &&
        !group.pathologies[0].NurseSignature
      ) {
        return true;
      }
    }
    return false;
  }

  removeMySignature(userType: string): void {
    this.pathologyService.removeSignature(this.inventoryId, userType).subscribe(
      (data) => {
        this.pathologyService
          .getInventoryDetails(this.inventoryId)
          .subscribe((data: any) => {
            this.nurseSigningDate = data.NurseSignedDate;
            this.secretarySigningDate = data.SecretarySignedDate;
            this.messengerSignedDate = data.MessengerSignedDate;
            this.getPathologies();
          });
      },
      (error) => {
        alert("Failed to remove signature");
      },
    );
  }
}
